<script lang="ts">
  import FailedAttachmentDisclaimer from './partials/FailedAttachmentDisclaimer.svelte';
  import UnSupportedAttachmentDisclaimer from './partials/UnSupportedAttachmentDisclaimer.svelte';
  import type { LicenseVerificationAttachment } from '$provider/models/license/LicenseVerificationAttachment';

  interface Props {
    attachment: LicenseVerificationAttachment;
    noAction?: boolean;
    onevent?: (payload: { type: 'click-attachment'; data: LicenseVerificationAttachment }) => void;
  }

  let { attachment, noAction = false, onevent }: Props = $props();

  const onClickAnchor = (): void => {
    if (attachment?.isExternalUrl) {
      window.open(attachment.source, '_blank');
      return;
    }

    if (attachment.isUnsupportedFileType) return;

    onevent?.({ type: 'click-attachment', data: attachment });
  };
</script>

<div class="license-change-attachment-list-type">
  <div class="attachment-link">
    <a class="link" href="/" data-cy={`attachment`} onclick={(e) => { e.preventDefault(); onClickAnchor(); }}>
      <span class="text">{attachment?.fileName}</span>
    </a>
  </div>
  {#if attachment?.isUnsupportedFileType}
    <UnSupportedAttachmentDisclaimer />
  {/if}
  {#if attachment?.isFailed}
    <FailedAttachmentDisclaimer simple {noAction} />
  {/if}
</div>

<style>
  .license-change-attachment-list-type {
    word-break: break-word;
  }
  .license-change-attachment-list-type .attachment-link {
    width: 100%;
    padding: 12px 16px;
    line-height: 20px;
  }

  .attachment-link .link {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: var(--blue);
    text-decoration: none;
  }
</style>
